import * as types from "./department.actionTypes";
import { createAsyncAction } from "typesafe-actions";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { DepartmentListResponse } from "./types";

export const getDepartmentAsync = createAsyncAction(
  types.GET_DEPARTMENT_REQUEST,
  types.GET_DEPARTMENT_SUCCESS,
  types.GET_DEPARTMENT_FAILURE
)<undefined, DepartmentListResponse, ErrorResponse>();